import { render, staticRenderFns } from "./DetailContentDownload.vue?vue&type=template&id=588799e4"
import script from "./DetailContentDownload.vue?vue&type=script&lang=js"
export * from "./DetailContentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports